// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1133":"datadogRecorder","9050":"datadogProfiler"}[chunkId] || chunkId) + "." + {"846":"f45fa25d35899111","1133":"4a674749a489ab27","8303":"5958c8d97195d1ef","9050":"470e452d1c5fdd68","9064":"89c1a959c8c55492"}[chunkId] + ".js";
};